import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  age: {
    description: 'ordersGrid.columns.age',
    defaultMessage: 'Age',
    id: 'fXryfG',
  },
  allocationStatus: {
    description: 'ordersGrid.columns.allocationStatus',
    defaultMessage: 'Allocation Status',
    id: 'V0TQPy',
  },
  unallocated: {
    description: 'Allocation Status value for Unallocated to show in Orders Grid',
    defaultMessage: 'Unallocated',
    id: 'rvvQmu',
  },
  allocated: {
    description: 'Allocation Status value for Allocated to show in Orders Grid',
    defaultMessage: 'Allocated',
    id: 'GYnysh',
  },
  insufficientInventory: {
    description: 'Allocation Status value for InsufficientInventory to show in Orders Grid',
    defaultMessage: 'Insufficient inventory',
    id: 'LPTKAn',
  },
  hasUntrackedShipFrom: {
    description: 'Allocation Status value for HasUntrackedShipFrom to show in Orders Grid',
    defaultMessage: 'Has untracked Ship From',
    id: 'IpZgv0',
  },
  neverAddedInventory: {
    description: 'Allocation Status value for NeverAddedInventory to show in Orders Grid',
    defaultMessage: 'Never added inventory',
    id: 'bbeXJb',
  },
  systemError: {
    description: 'Allocation Status value for SystemError to show in Orders Grid',
    defaultMessage: 'System error',
    id: '3AMo9H',
  },
  productHasNoTrackedInventory: {
    description: 'Allocation Status value for ProductHasNoTrackedInventory to show in Orders Grid',
    defaultMessage: 'Product has no tracked inventory',
    id: 'N2jc32',
  },
  fillOrder: {
    description: 'Allocation Status value for FillOrder to show in Orders Grid',
    defaultMessage: 'Fill Order',
    id: 'LA5p5U',
  },
  partiallyAllocated: {
    description: 'Allocation Status value for PartiallyAllocated to show in Orders Grid',
    defaultMessage: 'Partially Allocated',
    id: 'VsZLvB',
  },
  assignedTo: {
    description: 'ordersGrid.columns.assignedTo',
    defaultMessage: 'Assigned To',
    id: 'KhQeft',
  },
  batch: {
    description: 'ordersGrid.columns.batch',
    defaultMessage: 'Batch',
    id: '8snish',
  },
  brand: {
    description: 'ordersGrid.columns.brand',
    defaultMessage: 'Brand',
    id: '+frp7A',
  },
  buyerId: {
    description: 'ordersGrid.columns.buyerId',
    defaultMessage: 'Buyer ID',
    id: '0Dlyp3',
  },
  buyer: {
    description: 'ordersGrid.columns.buyer',
    defaultMessage: 'Buyer',
    id: 'LdPBtY',
  },
  carrier: {
    description: 'ordersGrid.columns.carrier',
    defaultMessage: 'Carrier',
    id: 'rI3Fa8',
  },
  client: {
    description: 'ordersGrid.columns.client',
    defaultMessage: 'Client',
    id: 'jPKnzL',
  },
  company: {
    description: 'ordersGrid.columns.company',
    defaultMessage: 'Company',
    id: 'NJRtzM',
  },
  confirmation: {
    description: 'ordersGrid.columns.confirmation',
    defaultMessage: 'Confirmation',
    id: 'RDA6Xx',
  },
  country: {
    description: 'ordersGrid.columns.country',
    defaultMessage: 'Country',
    id: 'C4eTQ0',
  },
  custom1: {
    description: 'ordersGrid.columns.custom1',
    defaultMessage: 'Custom Field 1',
    id: 'oHdwFw',
  },
  custom2: {
    description: 'ordersGrid.columns.custom2',
    defaultMessage: 'Custom Field 2',
    id: 'dkY9V/',
  },
  custom3: {
    description: 'ordersGrid.columns.custom3',
    defaultMessage: 'Custom Field 3',
    id: 'F8/Srs',
  },
  deliverBy: {
    description: 'Column header that displays the date by which an order should be delivered.',
    defaultMessage: 'Deliver By',
    id: 'Zd4wwe',
  },
  gift: {
    description: 'ordersGrid.columns.gift',
    defaultMessage: 'Gift',
    id: 'KndRLw',
  },
  holdUntil: {
    description: 'ordersGrid.columns.holdUntil',
    defaultMessage: 'Hold Until',
    id: 'Bjwwem',
  },
  holdIndefinitely: {
    description: 'Text displayed in the Hold Until column when an order is on hold indefinitely with no end date',
    defaultMessage: 'No end date',
    id: 'A9YxJU',
  },
  itemName: {
    description: 'ordersGrid.columns.itemName',
    defaultMessage: 'Item Name',
    id: 'zTB4+A',
  },
  numberOfItems: {
    description: 'number of items in nested rows within the orders grid.',
    defaultMessage: '({numberOfItems} Items)',
    id: 'BUsXOG',
  },
  itemSku: {
    description: 'ordersGrid.columns.itemSku',
    defaultMessage: 'Item SKU',
    id: 'v/D53I',
  },
  notes: {
    description: 'ordersGrid.columns.notes',
    defaultMessage: 'Notes',
    id: 'pH8/ED',
  },
  orderDate: {
    description: 'ordersGrid.columns.orderDate',
    defaultMessage: 'Order Date',
    id: '7LM+5u',
  },
  orderNumber: {
    description: 'ordersGrid.columns.orderNumber',
    defaultMessage: 'Order #',
    id: 'OjjfMd',
  },
  orderTotal: {
    description: 'ordersGrid.columns.orderTotal',
    defaultMessage: 'Order Total',
    id: 'DfT8j0',
  },
  package: {
    description: 'ordersGrid.columns.package',
    defaultMessage: 'Package',
    id: 'HGcbnN',
  },
  packingSlipPrinted: {
    description: 'ordersGrid.columns.packingSlipPrinted',
    defaultMessage: 'Packing Slip Printed',
    id: 'NYW8il',
  },
  warehouseStatus: {
    description: 'header for picking status column',
    defaultMessage: 'Picking Status',
    id: 'rdb9Fg',
  },
  pickListPrinted: {
    description: 'header for pick list printed column',
    defaultMessage: 'Pick List Printed',
    id: 'oVA8FT',
  },
  paidDate: {
    description: 'ordersGrid.columns.paidDate',
    defaultMessage: 'Paid Date',
    id: 'KNcCe/',
  },
  pickupStatus: {
    description: 'ordersGrid.columns.pickupStatus',
    defaultMessage: 'Pickup Status',
    id: 'EcEw+d',
  },
  pickupTime: {
    description: 'ordersGrid.columns.pickupTime',
    defaultMessage: 'Pickup Time',
    id: 'HKekfB',
  },
  premiumPrograms: {
    defaultMessage: 'Premium Programs',
    description:
      'Grid column header showing which "premium programs" are applied to the order. A "premium program" is a special service or feature that is applied to an order, such as expedited shipping.',
    id: 'vTUWwj',
  },
  printed: {
    description: 'Fulfillments Grid, Packing Slip Printed Column, Printed',
    defaultMessage: 'Printed',
    id: 'lGwq5b',
  },
  quantity: {
    description: 'ordersGrid.columns.quantity',
    defaultMessage: 'Quantity',
    id: 'hx3Imk',
  },
  rate: {
    description: 'ordersGrid.columns.rate',
    defaultMessage: 'Rate',
    id: 'I2pG1f',
  },
  recipient: {
    description: 'ordersGrid.columns.recipient',
    defaultMessage: 'Recipient',
    id: '8/AXe3',
  },
  requestedService: {
    description: 'ordersGrid.columns.requestedService',
    defaultMessage: 'Requested Service',
    id: 'yJhqHs',
  },
  service: {
    description: 'ordersGrid.columns.service',
    defaultMessage: 'Service',
    id: 'co1P8L',
  },
  serviceCollectionCellErrorMessage: {
    defaultMessage: 'Unable to retrieve rate. Check shipment configuration for details.',
    id: 'UK4MZa',
    description: 'Service collection cell error message',
  },
  rateShopperCellErrorMessage: {
    defaultMessage: 'Unable to retrieve rate. Check shipment configuration for details.',
    id: 'JWWTNL',
    description: 'Rate Shopper cell error message',
  },
  shipBy: {
    description: 'ordersGrid.columns.shipBy',
    defaultMessage: 'Ship By',
    id: 'sdLGq4',
  },
  shipDate: {
    description: 'ordersGrid.columns.shipDate',
    defaultMessage: 'Ship Date',
    id: 'YdVsTW',
  },
  shipFrom: {
    description: 'ordersGrid.columns.shipFrom',
    defaultMessage: 'Ship From',
    id: 'BYiTVC',
  },
  shippingAccount: {
    description: 'ordersGrid.columns.shippingAccount',
    defaultMessage: 'Shipping Account',
    id: 'XRNtD4',
  },
  shippingPaid: {
    description: 'ordersGrid.columns.shippingPaid',
    defaultMessage: 'Shipping Paid',
    id: 'nDn+o5',
  },
  source: {
    description: 'ordersGrid.columns.source',
    defaultMessage: 'Source',
    id: 'y+WfSy',
  },
  state: {
    description: 'ordersGrid.columns.state',
    defaultMessage: 'State',
    id: 'h+fbrr',
  },
  status: {
    description: 'ordersGrid.columns.status',
    defaultMessage: 'Status',
    id: 'nHNwXp',
  },
  store: {
    description: 'ordersGrid.columns.store',
    defaultMessage: 'Store',
    id: 'm6wicH',
  },
  tags: {
    description: 'ordersGrid.columns.tags',
    defaultMessage: 'Tags',
    id: 'D0m8pn',
  },
  taxPaid: {
    description: 'ordersGrid.columns.taxPaid',
    defaultMessage: 'Tax Paid',
    id: 'cendms',
  },
  warehouseLocation: {
    description: 'ordersGrid.columns.warehouseLocation',
    defaultMessage: 'Warehouse Location',
    id: 'pRlsNv',
  },
  weight: {
    description: 'ordersGrid.columns.weight',
    defaultMessage: 'Weight',
    id: 'qBLzxl',
  },
  zone: {
    description: 'ordersGrid.columns.zone',
    defaultMessage: 'Zone',
    id: 'RyhcdW',
  },
  selectServiceBy: {
    description: 'Shipping service group selector',
    defaultMessage: 'Sort By',
    id: 'dY/apI',
  },
  selectByCarrier: {
    description: 'Select service by carrier option box',
    defaultMessage: 'Carrier',
    id: 'L35X2k',
  },
  selectByPostageProvider: {
    description: 'Select service by postage provider option box',
    defaultMessage: 'Postage Provider',
    id: 'DLJBkM',
  },
  columnDropdownNoneSelected: {
    description: 'Order Grid Column Dropdown -> None Selected',
    defaultMessage: 'None',
    id: 'i1od6e',
  },
  columnDropdownNameNobody: {
    description: 'Order Grid Column Dropdown -> Nobody',
    defaultMessage: '(Nobody)',
    id: 'aYQfkP',
  },
  warehouseStatusCancelled: {
    description: 'Warehouse Status value for Cancelled to show in Orders Grid',
    defaultMessage: 'Cancelled',
    id: 'CtqWN0',
  },
  warehouseStatusReadyToPick: {
    description: 'Warehouse Status value for ReadyToPick to show in Orders Grid',
    defaultMessage: 'Ready To Pick',
    id: 'CSwH5W',
  },
  warehouseStatusPicking: {
    description: 'Warehouse Status value for Picking to show in Orders Grid',
    defaultMessage: 'Picking',
    id: 'JNVmho',
  },
  warehouseStatusPicked: {
    description: 'Warehouse Status value for Picked to show in Orders Grid',
    defaultMessage: 'Picked',
    id: 'F1aATE',
  },
  rateWarningTitle: {
    description: 'title for the flyout popover',
    defaultMessage: 'Rate Warning',
    id: 'Gl+vsm',
  },
  rateShopper: {
    description: 'Column header text for Rate Shopper',
    defaultMessage: 'Rate Shopper',
    id: 'GGoHIP',
  },
  sortBy: {
    description: 'sort by for shipping services',
    defaultMessage: 'Sort by',
    id: 'f7Msda',
  },
  fulfillmentStatus: {
    description: 'title for the fulfillment status column in the orders grid',
    defaultMessage: 'Fulfillment Status',
    id: 'uSJQbG',
  },
  fulfillmentStatusTooltipTitle: {
    description: 'Fulfillment Status Tooltip Title',
    defaultMessage: '{header}: {status}',
    id: 'FU/tyz',
  },
  pickingException: {
    description: 'ordersGrid.columns.pickingException',
    defaultMessage: 'Picking Exception',
    id: 'cvoaOo',
  },
  pickingExceptionNone: {
    description: 'Picking Exception value for None to show in Orders Grid',
    defaultMessage: 'None',
    id: 'eTwWoy',
  },
  pickingExceptionNotEnoughStock: {
    description: 'Picking Exception value for Not enough stock to show in Orders Grid',
    defaultMessage: 'Not enough stock',
    id: 'M1nkbQ',
  },
  pickingExceptionProductDamaged: {
    description: 'Picking Exception value for Damaged Inventory to show in Orders Grid',
    defaultMessage: 'Damaged Inventory',
    id: 'jKmRv8',
  },
  pickingExceptionProductNotFound: {
    description: 'Picking Exception value for Product not at location to show in Orders Grid',
    defaultMessage: 'Product not at location',
    id: 'RYlRft',
  },
  pickingExceptionOther: {
    description: 'Picking Exception value for Other to show in Orders Grid',
    defaultMessage: 'Other',
    id: 'cLy3Le',
  },
  pickingExceptionMultiple: {
    description: 'Picking Exception value for Multiple products with exceptions to show in Orders Grid',
    defaultMessage: 'Multiple',
    id: 'EzEGWf',
  },
  tote: {
    description: 'header for tote column showing the assigned tote name in Orders Grid',
    defaultMessage: 'Tote',
    id: 'lS1lkB',
  },
});
